import { Story } from "@/hooks/useStories";

interface StoryCircleProps {
  story: Story;
  onClick: () => void;
}

export function StoryCircle({ story, onClick }: StoryCircleProps) {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-1 shrink-0 group"
      aria-label={`View story${story.location_tag ? ` from ${story.location_tag}` : ""}`}
    >
      {/* Gold gradient ring */}
      <div className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-full p-[3px] bg-gradient-to-br from-[hsl(38,92%,50%)] via-[hsl(30,95%,55%)] to-[hsl(45,90%,45%)] group-hover:scale-105 transition-transform">
        {/* White gap */}
        <div className="w-full h-full rounded-full p-[2px] bg-background">
          {/* Image circle */}
          <div className="w-full h-full rounded-full overflow-hidden">
            {story.media_type === "video" && story.video_url ? (
              <video
                src={story.video_url}
                className="w-full h-full object-cover"
                muted
                playsInline
                preload="metadata"
              />
            ) : (
              <img
                src={story.image_url}
                alt={story.caption || "Job site story"}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            )}
          </div>
        </div>
      </div>
      {/* Location tag below circle */}
      {story.location_tag && (
        <span className="text-[10px] md:text-xs text-muted-foreground max-w-[72px] truncate text-center">
          {story.location_tag}
        </span>
      )}
    </button>
  );
}
